import { render, staticRenderFns } from "./SankeyWrapper.vue?vue&type=template&id=6a5eea6f&"
import script from "./SankeyWrapper.vue?vue&type=script&lang=ts&"
export * from "./SankeyWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports